export default __webpack_public_path__ + "static/media/factory__33.733addcd.jpg";